<template>
  <div class="page">
    <div class="page-bd max">
      <div class="table-box pd-20">
        <pageTitle
          :title="$t('page_title.platform_role')"
          :newButShow="true"
          @newBut="newBut('add')"
        ></pageTitle>
        <myTableFilter @submit="handleSubmit" :show="{ role_name: true }" />
        <myTable ref="table" :columns="columns" requestUrl="edu-role/list" :showPage="true">
          <template v-slot:action="{ data }">
            <Icon
              class="cursor_p"
              type="md-create"
              size="24"
              color="#1F8FC8"
              @click="newBut('edit',data.row)"
            />
          </template>
          <template v-slot:reg_image="{ data }">
            <div class="imgList">
              <img :src="data.row.reg_image" />
            </div>
          </template>
        </myTable>
      </div>
    </div>
    <edit
      v-if="modal"
      @onOk="onOk"
      :type="type"
      :roleList="roleList"
      :modal="modal"
      :itemObj="itemObj"
      @cancel="cancel"
    ></edit>
  </div>
</template>

<script>
import myTable from "@/components/myTable";
import pageTitle from "@/components/pageTitle";
import myTableFilter from "@/components/myTableFilter";
import edit from "./module/role_edit";
export default {
  name: "role",
  components: {
    myTable,
    pageTitle,
    myTableFilter,
    edit
  },
  data () {
    return {
      columns: [
        {
          title: this.$t("role"),
          key: "role_cdesc",
          align: "center",
          width: 100,
        },
        {
          title: this.$t("Role.name") + "(EN)",
          key: "en_cname",
          align: "center"
        },
        {
          title: this.$t("Role.name") + "(繁体)",
          key: "zh-tw_cname",
          align: "center"
        },
        {
          title: this.$t("Role.name") + "(简体)",
          key: "zh-cn_cname",
          align: "center"
        },
        {
          title: this.$t("img_lnk"),
          slot: "reg_image",
          align: "center",
          //   render: (h, params) => {
          //     return h('img', {
          //       attrs: {
          //         src: params.row.reg_image
          //       },
          //       style: {
          //         width: '80px',
          //         height: '80px',
          //         'margin-top': '5px'
          //       }
          //     })
          //   }
        },
        {
          title: this.$t("Info.order"),
          key: "sort_id",
          align: "center"
        },
        {
          title: this.$t("status"),
          width: 120,
          key: "status",
          align: "center",
          render: (h, params) => {
            //return h('元素',{元素的性质},'内容')
            return h('i-switch', {
              props: {
                size: 'large',
                value: params.row.status == 1
              },
              on: {
                'on-change': value => {
                  this.setStatus(params.row.role_id);
                }
              }
            });
          }
        },
        {
          title: this.$t("op"),
          align: "center",
          slot: "action",
          width: 100,
        },
      ],
      modal: false,
      itemObj: {},
      type: "add",
      roleList: []
    };
  },
  created () {
    this.getBeforeList();
  },
  mounted () {
    this.$base.setMenuOpens();
  },
  methods: {
    handleSubmit (params) {
      this.$refs.table.reSearch(params);
    },
    getBeforeList () {
      this.$base.showLoading();
      this.$request.sendPost("edu-role/before-add", {}, (success, data, error) => {
        this.$base.hideLoading();
        if (!success) return this.$base.msgErr(error.errmsg);
        this.roleList = data.roles
      }
      );
    },

    newBut (type, item) {
      this.type = type
      this.itemObj = item
      this.modal = true
    },
    cancel () {
      this.modal = false
    },
    onOk () {
      this.$base.msgSuccess(this.$t("op_ok"));
      this.$refs.table.getLoad();
    },
    setStatus (role_id) {
      this.$base.showLoading();
      this.$request.sendPost(
        'edu-role/upd_status',
        { role_id: role_id },
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.alertErr(error.errmsg);
          this.onOk()
        }
      );
    },
  }
};
</script>

<style lang="less" scoped>
/deep/ .ivu-table-cell-slot {
  display: flex;
  justify-content: center;
}
.imgList {
  width: 80px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/edu/role/role.vue